<template>
  <div class="mod-page sat-catalog-page">
    <div class="mod-header">
      <div>
        <h1 class="mod-title">Catálogos SAT</h1>
        <p class="mod-subtitle">Administración de catálogos fiscales SAT</p>
      </div>
    </div>

    <div class="sat-summary">
      <div class="sat-metric">
        <span class="sat-metric-value">{{ catalogos.length }}</span>
        <span class="sat-metric-label">Catálogos disponibles</span>
      </div>
      <div class="sat-metric">
        <span class="sat-metric-value">{{ principales.length }}</span>
        <span class="sat-metric-label">Prioritarios para CFDI</span>
      </div>
    </div>

    <div class="mod-table-wrap">
      <table class="mod-table sat-table">
        <thead>
          <tr>
            <th>Catálogo</th>
            <th>Tabla global</th>
            <th>Tabla por empresa</th>
            <th>Grupo</th>
            <th>Estado</th>
            <th class="mod-th-actions">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in catalogos" :key="item.tabla" class="mod-tr">
            <td>
              <strong>{{ item.nombre }}</strong>
              <div class="mod-td-muted">{{ item.descripcion }}</div>
            </td>
            <td><span class="mod-badge">{{ item.tabla }}</span></td>
            <td><span class="mod-badge">{{ item.tablaEmpresa }}</span></td>
            <td>{{ item.grupo }}</td>
            <td>
              <span :class="item.ruta ? 'mod-status-active' : 'mod-status-inactive'">
                {{ item.ruta ? 'Disponible' : 'Pendiente' }}
              </span>
            </td>
            <td class="mod-td-actions">
              <button
                class="mod-btn-icon"
                title="Abrir"
                :disabled="!item.ruta"
                @click="openCatalog(item)"
              >
                <i class="bi bi-box-arrow-up-right"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
const catalogos = [
  { nombre: 'Forma de pago', tabla: 'sat_FormaPago', tablaEmpresa: 'sat_FormaPago_e', grupo: 'CFDI', descripcion: 'Formas de pago SAT', ruta: '/catalogos/sat/formas-pago' },
  { nombre: 'Método de pago', tabla: 'sat_MetodoPago', tablaEmpresa: 'sat_MetodoPago_e', grupo: 'CFDI', descripcion: 'Métodos PUE/PPD', ruta: '/catalogos/sat/metodos-pago' },
  { nombre: 'Uso CFDI', tabla: 'sat_UsoCFDI', tablaEmpresa: 'sat_UsoCFDI_e', grupo: 'CFDI', descripcion: 'Usos fiscales del receptor', ruta: '/catalogos/sat/sat_uso_cfdi' },
  { nombre: 'Régimen fiscal', tabla: 'sat_RegimenFiscal', tablaEmpresa: 'sat_RegimenFiscal_e', grupo: 'CFDI', descripcion: 'Regímenes fiscales SAT', ruta: '/catalogos/sat/sat_regimen_fiscal' },
  { nombre: 'Objeto impuesto', tabla: 'sat_ObjetoImp', tablaEmpresa: 'sat_ObjetoImp_e', grupo: 'CFDI', descripcion: 'Objeto de impuesto por concepto', ruta: '/catalogos/sat/sat_objeto_imp' },
  { nombre: 'Clave producto servicio', tabla: 'sat_ClaveProdServ', tablaEmpresa: 'sat_ClaveProdServ_e', grupo: 'Conceptos', descripcion: 'Claves de productos y servicios', ruta: '/catalogos/sat/sat_clave_prod_serv' },
  { nombre: 'Impuesto', tabla: 'sat_Impuesto', tablaEmpresa: 'sat_Impuesto_e', grupo: 'Impuestos', descripcion: 'ISR, IVA, IEPS y clasificación', ruta: '/catalogos/sat/sat_impuesto' },
  { nombre: 'Tipo de comprobante', tabla: 'sat_TipoDeComprobante', tablaEmpresa: 'sat_TipoDeComprobante_e', grupo: 'CFDI', descripcion: 'Ingreso, egreso, traslado, pago y nómina', ruta: '/catalogos/sat/sat_tipo_de_comprobante' },
  { nombre: 'Tipo relación', tabla: 'sat_TipoRelacion', tablaEmpresa: 'sat_TipoRelacion_e', grupo: 'CFDI', descripcion: 'Relaciones entre comprobantes', ruta: '/catalogos/sat/sat_tipo_relacion' },
  { nombre: 'Exportación', tabla: 'sat_Exportacion', tablaEmpresa: 'sat_Exportacion_e', grupo: 'Comercio exterior', descripcion: 'Claves de exportación SAT', ruta: '/catalogos/sat/sat_exportacion' },
  { nombre: 'Código postal', tabla: 'sat_CodigoPostal', tablaEmpresa: 'sat_CodigoPostal_e', grupo: 'Ubicación', descripcion: 'Códigos postales SAT', ruta: '/catalogos/sat/sat_codigo_postal' },
  { nombre: 'Colonia', tabla: 'sat_Colonia', tablaEmpresa: 'sat_Colonia_e', grupo: 'Ubicación', descripcion: 'Colonias por código postal', ruta: '/catalogos/sat/sat_colonia' },
  { nombre: 'Estado', tabla: 'sat_Estado', tablaEmpresa: 'sat_Estado_e', grupo: 'Ubicación', descripcion: 'Estados por país SAT', ruta: '/catalogos/sat/sat_estado' },
  { nombre: 'Municipio', tabla: 'sat_Municipio', tablaEmpresa: 'sat_Municipio_e', grupo: 'Ubicación', descripcion: 'Municipios por estado', ruta: '/catalogos/sat/sat_municipio' },
  { nombre: 'Localidad', tabla: 'sat_Localidad', tablaEmpresa: 'sat_Localidad_e', grupo: 'Ubicación', descripcion: 'Localidades por estado', ruta: '/catalogos/sat/sat_localidad' },
  { nombre: 'Aduana', tabla: 'sat_Aduana', tablaEmpresa: 'sat_Aduana_e', grupo: 'Comercio exterior', descripcion: 'Aduanas SAT', ruta: '/catalogos/sat/sat_aduana' },
  { nombre: 'Meses', tabla: 'sat_Meses', tablaEmpresa: 'sat_Meses_e', grupo: 'Periodicidad', descripcion: 'Meses para comprobantes globales', ruta: '/catalogos/sat/sat_meses' },
  { nombre: 'Periodicidad', tabla: 'sat_Periodicidad', tablaEmpresa: 'sat_Periodicidad_e', grupo: 'Periodicidad', descripcion: 'Periodicidad de comprobantes globales', ruta: '/catalogos/sat/sat_periodicidad' },
  { nombre: 'Catálogo CP extendido', tabla: 'sat_cat_cp', tablaEmpresa: 'sat_cat_cp_e', grupo: 'Ubicación', descripcion: 'Catálogo postal extendido', ruta: '/catalogos/sat/sat_cat_cp' },
  { nombre: 'Estados SEPOMEX', tabla: 'sat_cat_edo', tablaEmpresa: 'sat_cat_edo_e', grupo: 'Ubicación', descripcion: 'Catálogo auxiliar de estados', ruta: '/catalogos/sat/sat_cat_edo' }
];

export default {
  name: 'SatCatalogosView',
  data() {
    return { catalogos };
  },
  computed: {
    principales() {
      return this.catalogos.filter(item => ['CFDI', 'Impuestos'].includes(item.grupo));
    }
  },
  methods: {
    openCatalog(item) {
      if (item.ruta) this.$router.push(item.ruta);
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

.sat-catalog-page {
  max-width: 1180px;
}

.sat-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 220px));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.sat-metric {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 0.85rem 1rem;
}

.sat-metric-value {
  display: block;
  color: #1a202c;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1;
}

.sat-metric-label {
  color: #718096;
  font-size: 0.78rem;
}

.sat-table {
  min-width: 860px;
}

@media (max-width: 640px) {
  .sat-summary {
    grid-template-columns: 1fr;
  }
}
</style>
